import React from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../Components/Common/ChartsDynamicColor";

const AttendanceCharts = ({ dataColors, series, categories }: any) => {
  var chartColors = getChartColorsArray(dataColors);

  var options: any = {
    chart: {
      height: 370,
      type: "bar",
      stacked: false,
      toolbar: {
        show: false,
      },
    },
    stroke: {
      width: 0,
    },
    plotOptions: {
      bar: {
        columnWidth: "50%",
        borderRadius: 4,
      },
    },
    fill: {
      opacity: 0.85,
    },
    labels: categories,
    markers: {
      size: 0,
    },
    xaxis: {
      type: "category",
      categories: categories,
      labels: {
        rotate: -45,
        rotateAlways: false,
        style: {
          fontSize: "12px",
        },
      },
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
      },
    },
    yaxis: {
      title: {
        text: "Jumlah Karyawan",
        style: {
          fontSize: "14px",
          fontWeight: 500,
        },
      },
      labels: {
        formatter: function (value: number) {
          return Math.floor(value);
        },
      },
      min: 0,
    },
    grid: {
      show: true,
      borderColor: "#f1f1f1",
      strokeDashArray: 3,
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
      padding: {
        top: 0,
        right: 10,
        bottom: 0,
        left: 10,
      },
    },
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "right",
      offsetY: 0,
      markers: {
        width: 10,
        height: 10,
        radius: 6,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 5,
      },
    },
    colors: chartColors,
    tooltip: {
      shared: true,
      intersect: false,
      custom: function ({ series, seriesIndex, dataPointIndex, w }: any) {
        // Ambil categories dari w.globals.labels atau w.config.xaxis.categories
        const categories = w.globals.labels || w.config.xaxis.categories || [];
        const date = categories[dataPointIndex] || "N/A";
        const seriesData = w.config.series;

        let html = `<div style="padding: 12px; max-width: 350px; box-shadow: 0 4px 6px rgba(0,0,0,0.1); background: white; border-radius: 6px;">`;
        html += `<div style="margin-bottom: 10px; font-weight: 600; font-size: 13px; border-bottom: 1px solid #e5e7eb; padding-bottom: 6px;">${date}</div>`;

        seriesData.forEach((s: any, idx: number) => {
          const value = s.data[dataPointIndex];
          const members = s.members?.[dataPointIndex] || [];
          const color = chartColors[idx];

          if (value > 0) {
            html += `<div style="margin-bottom: 8px;">`;
            html += `<div style="display: flex; align-items: center; gap: 6px; margin-bottom: 4px;">`;
            html += `<span style="color: ${color}; font-size: 16px;">●</span>`;
            html += `<span style="font-weight: 600; font-size: 12px;">${s.name}: ${value}</span>`;
            html += `</div>`;

            if (members.length > 0) {
              // Tampilkan maksimal 5 nama pertama
              const maxShow = 2;
              const displayMembers = members.slice(0, maxShow);
              const remaining = members.length - maxShow;

              html += `<div style="font-size: 10px; margin-left: 22px; color: #6b7280; line-height: 1.5;">`;
              html += displayMembers.join(", ");

              if (remaining > 0) {
                html += `<span style="font-weight: 600; color: #4b5563;"> +${remaining} lainnya</span>`;
              }

              html += `</div>`;
            }
            html += `</div>`;
          }
        });

        html += `</div>`;
        return html;
      },
    },
    dataLabels: {
      enabled: false,
    },
  };

  return (
    <React.Fragment>
      <ReactApexChart
        dir="ltr"
        options={options}
        series={series}
        type="bar"
        height="370"
        className="apex-charts"
      />
    </React.Fragment>
  );
};

const StoreVisitsCharts = ({ dataColors }: any) => {
  var chartDonutBasicColors = getChartColorsArray(dataColors);
  const series = [44, 55, 41, 17, 15];
  var options: any = {
    labels: ["Direct", "Social", "Email", "Other", "Referrals"],
    chart: {
      height: 333,
      type: "donut",
    },
    legend: {
      position: "bottom",
    },
    stroke: {
      show: false,
    },
    dataLabels: {
      dropShadow: {
        enabled: false,
      },
    },
    colors: chartDonutBasicColors,
  };
  return (
    <React.Fragment>
      <ReactApexChart
        dir="ltr"
        options={options}
        series={series}
        type="donut"
        height="333"
        className="apex-charts"
      />
    </React.Fragment>
  );
};

// Keep the original RevenueCharts for backward compatibility
const RevenueCharts = ({ dataColors, series }: any) => {
  var linechartcustomerColors = getChartColorsArray(dataColors);

  var options: any = {
    chart: {
      height: 370,
      type: "line",
      toolbar: {
        show: false,
      },
    },
    stroke: {
      curve: "straight",
      dashArray: [0, 0, 8],
      width: [2, 0, 2.2],
    },
    fill: {
      opacity: [0.1, 0.9, 1],
    },
    markers: {
      size: [0, 0, 0],
      strokeWidth: 2,
      hover: {
        size: 4,
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
    },
    grid: {
      show: true,
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
      padding: {
        top: 0,
        right: -2,
        bottom: 15,
        left: 10,
      },
    },
    legend: {
      show: true,
      horizontalAlign: "center",
      offsetX: 0,
      offsetY: -5,
      markers: {
        width: 9,
        height: 9,
        radius: 6,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 0,
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "30%",
        barHeight: "70%",
      },
    },
    colors: linechartcustomerColors,
    tooltip: {
      shared: true,
      y: [
        {
          formatter: function (y: any) {
            if (typeof y !== "undefined") {
              return y.toFixed(0);
            }
            return y;
          },
        },
        {
          formatter: function (y: any) {
            if (typeof y !== "undefined") {
              return "$" + y.toFixed(2) + "k";
            }
            return y;
          },
        },
        {
          formatter: function (y: any) {
            if (typeof y !== "undefined") {
              return y.toFixed(0) + " Sales";
            }
            return y;
          },
        },
      ],
    },
  };
  return (
    <React.Fragment>
      <ReactApexChart
        dir="ltr"
        options={options}
        series={series}
        type="line"
        height="370"
        className="apex-charts"
      />
    </React.Fragment>
  );
};

export { RevenueCharts, AttendanceCharts, StoreVisitsCharts };
